import { combineReducers } from 'redux';
import donor from './donorReducer';
import patient from './patientReducer';
import locality from './localityReducer';

const rootReducer = combineReducers({
  donor, patient, locality
});

export default rootReducer;